<template>
  <li class="target box_product">
    <!-- 動的HTML生成部 コミッション対象商品一覧 -->
    <div class="py-3 text-center box_product_title">
      <h4>{{ title }}</h4>
    </div>
    <div class="d-flex align-items-center">
      <img class="w-50 pl-5" :src="thumb" @error="noImage()" :alt="title" />
      <div class="w-50">
        <div>
          <router-link v-show="detail" :to="url">商品詳細を見る</router-link>
          <div class="h-auto">{{ price }}円</div>
          <div>{{ showPoint }}ポイント</div>
          <div class="mt-2">
            <select v-model="count" class="select_no">
              <option value="0">0</option>
              <option v-for="num in parseInt(limit)" :value="num" :key="num">
                {{ num }}
              </option>
            </select>
            個
          </div>
        </div>
      </div>
    </div>
    <div class="p-2 box_product_submit" v-if="fastShow">※エコキャンペーン第5弾開催期間につき、11/29(土)16時までにご注文いただきますと「専用リユースボトル」がプレゼントになります。</div>
    <div class="box-p-20 text-center box_product_submit">
      <button type="button" class="btn" v-on:click="addToCart">
        カートに入れる
      </button>
    </div>
  </li>
</template>

<style scoped>
.box_product div:first-child {
  padding: 1.5rem;
}
.box_product .box_product_submit {
  color: #a52a2a;
}

@media screen and (min-width: 1px) and (max-width: 350px) {
  .box_product > div:first-child {
    height: initial;
  }
  .box_product > div:nth-child(2) {
    flex-direction: column;
  }
  .box_product > div:nth-child(2) img.w-50 {
    width: 150px !important;
    padding-left: 0px !important;
  }
  .box_product > div:nth-child(2) div.w-50 {
    width: 100% !important;
    text-align: center;
  }
}
</style>

<script>
import Request from "@/modules/Request";
let request = new Request();
import Message from "@/modules/Message";
import Products from "@/modules/Products";
let productStore = new Products();

export default {
  props: ["no", "title", "limit", "type", "code", "price", "point", "isProxy"],
  data() {
    let product = productStore.getProduct(this.no);

    // 詳細ページのURLを作成する
    let queries = [
      "title=" + this.title,
      "limit=" + this.limit,
      "type=" + this.type,
      "code=" + this.code,
    ];
    return {
      // 詳細ページの有無
      detail: product ? product.detail : false,
      // サムネの場所は該当商品のディレクトリ下にthumb.jpg
      thumb: process.env.VUE_APP_CONTENTS_PRODUCT_HOME + this.no + "/thumb.jpg",
      // 数量は0初期化
      count: 0,
      // 画面遷移先URL
      url: "/products/" + this.no + "?" + queries.join("&"),

      showPoint :0,
      fastShow :false,
    };
  },
  mounted() {
    if(this.point == ''){
      this.showPoint = 0;
    }else{
      this.showPoint = this.point;
    }
    if(this.no == '068' || this.no == '088'){
      this.fastShow = true;
    }
    // if(this.no == '057' || this.no == '058'){
    //   const today = new Date();
    //   const targetDate = new Date('2025-02-01');
    //   if(today >= targetDate) {
    //     this.showPoint *= 2;
    //   }
    // }
  },
  watch:{
    point: function () {
      if(this.point == ''){
        this.showPoint = 0;
      }else{
        this.showPoint = this.point;
      }
    },
  },
  methods: {
    noImage() {
      // 画像の読み込みに失敗すればnoimage
      this.thumb = process.env.VUE_APP_CONTENTS_PRODUCT_HOME + "/nothumb.jpg";
    },
    addToCart() {
      let postParams = [this.type, this.code, this.count];
      let requestParams = request.createParams(
        "webMdlCart",
        "putCart",
        postParams
      );
      request
        .create()
        .post("", requestParams)
        .then(() => {
          console.log('addToCart,then')
          Message.success().fire({
            title: "カートに商品を追加しました",
            text: this.title + " : " + this.count + "個",
          });
          // this.$store.commit("refreshCart", "");
          // 選択したカウントを初期化する
          this.count = 0;
          this.$emit('add');
        })
    },
  },
};
</script>
